import {Component, Input, OnInit, ViewEncapsulation} from '@angular/core';

@Component({
  selector: 'app-team-node',
  templateUrl: './team-node.component.html',
  styleUrls: ['./team-node.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class TeamNodeComponent implements OnInit {

  @Input() teamList
  constructor() { }

  ngOnInit() {}

  openTeam($event: MouseEvent, id) {


  }
}
